<template lang="pug">
div
  v-card-text
    v-row.mb-4
      v-col(cols="auto")
        h3.mb-2 Venta anual según Plan de ventas
        h1.primary--text {{ totalSales | moneyMM }}
      v-col(cols="auto")
        h3.mb-2 Margen bruto de Plan de ventas
        h1.primary--text {{ totalProfit | moneyMM }}
    v-row
      v-col(cols="12" md="auto")
        v-select(v-model="chartBy" :items="chartByOptions" label="Agrupar gráfico por" outlined)
        v-card-text
    .chart-wrap(style="position: relative; height: 360px; width: 100%")
      Bar(:chart-data="chartData" :chart-options="chartOptions" :chart-id="id" :plugins="chartPlugins" :styles="{position:'relative',height:'100%',width:'100%'}")
</template>


<script>
import { Bar } from 'vue-chartjs/legacy'
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { mapActions } from 'vuex'
import chartsUtils from '@/utils/chartsUtils'
import { fmtMoneyMM } from '@/utils/customVueFilters'
ChartJS.register(Title, Tooltip, BarElement, CategoryScale, Legend, LinearScale)

export default {
  props: {
    filters: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  components: {
    Bar,
  },
  data() {
    return {
      id: this._uid.toString(),
      chartPlugins: [ChartDataLabels],
      marketSize: 0,
      totalSales: 0,
      totalProfit: 0,
      form: {
        growthRate: 0
      },
      chartBy: 'customer',
      chartByOptions: [
        { value: 'customer', text: 'Cliente' },
        { value: 'product', text: 'Producto' }
      ],
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            stacked: true,
          },
          y: {
            stacked: true,
            ticks: { callback: (value) => fmtMoneyMM(value) }
          }
        },
        plugins: {
          legend: {
            display: true,
            position: 'top',
          },
          tooltip: {
            callbacks: {
              label: function(context) {
                return fmtMoneyMM(context.raw)
              },
              title: function(context) {
                const label = context[0].dataset.label
                return label
              }
            }
          },
          datalabels: {
            color: '#fff',
            font: { size: 9, weight: '500' },
            display: 'auto',
            formatter: function(value) {
              if (!value || value < 1e6) return null
              return fmtMoneyMM(value)
            }
          }
        }
      },
      chartData: {
        labels: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
        datasets: [
          {
            label: 'Potencial en $',
            data: [],
            backgroundColor: chartsUtils.colors,
            hoverBackgroundColor: chartsUtils.colors
          }
        ]
      },
      v: {
        growthRate: [
          v => !!v || 'Este campo es requerido',
          v => v >= 0 || 'El valor debe ser mayor o igual a 0'
        ]
      }
    }
  },
  computed: {
    computedMarketSize() {
      return this.chartData.datasets[0].data.reduce((acc, value) => acc + value, 0)
    }
  },
  methods: {
    ...mapActions('commercial_projection', ['getSalePlanByCustomerChart', 'exportOptimalMix', 'getSalePlanByProductChart', 'getStatisticsSalePlan']),
    exportData() {
      this.exportOptimalMix({
        projection: this.$route.params.id,
        ...this.filters
      })
    },
    async fetchStatistics() {
      const params = {
        ...this.filters,
        projection: this.projection || this.$route.params.id
      }
      const { data, error } = await this.getStatisticsSalePlan(params)

      if (!error) {
        this.totalProfit = data.total_profit
        this.totalSales = data.total_sales
      }
    },
    async fetchData() {
      const params = {
        ...this.filters,
        projection: this.$route.params.id
      }

      this.fetchStatistics()
      const action = this.chartBy === 'customer' ? this.getSalePlanByCustomerChart : this.getSalePlanByProductChart

      const { data, error } = await action(params)

      if (!error) {
        const grouped = this.groupTopNSeries(data.datasets, chartsUtils.colors.length - 1)
        this.chartData.datasets = grouped.map((dataset, index) => {
          const color = dataset.label === 'Otros'
            ? '#B9C4CC'
            : chartsUtils.colors[index % chartsUtils.colors.length]
          return {
            label: dataset.label,
            data: dataset.data,
            backgroundColor: color,
            hoverBackgroundColor: color
          }
        })
      }
    },
    // Agrupa las series dejando máximo `maxSeries` y sumando el resto en "Otros"
    // (evita colisión de colores en la barra apilada cuando hay muchas series).
    groupTopNSeries(datasets, maxSeries) {
      if (!datasets || datasets.length <= maxSeries) return datasets || []
      const withTotal = datasets.map(d => ({
        d,
        total: (d.data || []).reduce((a, b) => a + (Number(b) || 0), 0)
      }))
      withTotal.sort((a, b) => b.total - a.total)
      const keep = withTotal.slice(0, maxSeries).map(x => x.d)
      const rest = withTotal.slice(maxSeries).map(x => x.d)
      const n = (keep[0] && keep[0].data) ? keep[0].data.length : 12
      const otros = {
        label: 'Otros',
        data: Array.from({ length: n }, (_, i) =>
          rest.reduce((acc, d) => acc + (Number((d.data || [])[i]) || 0), 0))
      }
      return keep.concat(otros)
    },
  },
  watch: {
    filters: {
      handler() {
        this.fetchData()
      },
      deep: true,
    },
    chartBy() {
      this.fetchData()
    }
  },
  created() {
    this.fetchData()
  }
}
</script>
